import React from "react";
import RandomizeChart from "../../CommonComponents/Chart";

const Chart = (props) => {
    return <div>
        {Object.keys(props.randomData).length ? (
            <RandomizeChart chartData={props.randomData} />) : null}
    </div>
}

export default Chart;